import {EventEmitter} from 'events';

const CHANGE_EVENT = 'change';
const TOGGLE_ACTIVE_EVENT = 'toggle_active';
const SELECT_EVENT = 'select_event';

export {CHANGE_EVENT, TOGGLE_ACTIVE_EVENT, SELECT_EVENT}

export default class stateClass extends EventEmitter{
    
    constructor() {

        super();
        this.data = []; //[{name: 'asdasd', count: 23, ...}, ...]
        this.chartKey = null;
        this.active = false;
    }
    emit(name, ...args) {

        console.log('EMIT ', name, this);

        EventEmitter.prototype.emit.call(this, name, arguments);
    }
    update(data) {

        this.data = data;
        
        this.emit(CHANGE_EVENT);
    }
    get() {
        return this.data;
    }
    getState() {
        return this.state;
    }
    setChartKey(key){

        this.chartKey = key;

        this.emit('chartKeyChange');
    }

    getChartKey() {

        return this.chartKey;
    }
    selectEvent(data) {

        this.selectedData = data;

        this.emit(SELECT_EVENT);
    }
    getSelected () {

        return this.selectedData;
    }
    toggleActive(active) {

        if(typeof active === 'boolean'){

            this.active = active;
            this.emit(TOGGLE_ACTIVE_EVENT);
            return;
        }

        if(this.active) {
            this.active = false;
        } else {
            this.active = true;
        }

        this.emit(TOGGLE_ACTIVE_EVENT);
    }

    getActive() {

        return this.active;
    }

    recursiveDataLoop(callback) {

        var level = 0;
        function dataloop(item, parentIndex, level) {

            for (var i = item.length - 1; i >= 0; i--) {

                callback(item[i], parentIndex, level);
                if(item[i].childs && item[i].childs.length > 0) {

                    dataloop(item[i].childs, i, level++);
                }
            }
            
        }

        dataloop(this.data, null, 0);
    }
}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/baseState.js